import {
    PrescriberOrderStatus,
    type PriorAuthorizationInfoFragment,
    PriorAuthorizationStatus,
} from '../../graphql/generated/graphql';
import { usePriorAuthorizationDetails } from '../../hooks/use-prior-authorization-details';
import type { BasicPrescriberOrderFragment } from '../cabinet/prescriber-orders';

export const isNewOrder = (
    order: BasicPrescriberOrderFragment | PriorAuthorizationInfoFragment
) => {
    // oxlint-disable-next-line react-hooks/rules-of-hooks -- tracked in docs/oxlint-violations.md
    const { priorAuthorizationDetails } = usePriorAuthorizationDetails(order);

    if ('status' in order) {
        if (order.__typename !== 'PriorAuthorization') {
            return (
                order.status === PrescriberOrderStatus.New ||
                order.status === PrescriberOrderStatus.Pending
            );
        } else if (order.__typename === 'PriorAuthorization') {
            switch (priorAuthorizationDetails?.status) {
                case PriorAuthorizationStatus.New:
                case PriorAuthorizationStatus.Received:
                case PriorAuthorizationStatus.InReview:
                case PriorAuthorizationStatus.Appealed:
                case PriorAuthorizationStatus.Redetermination:
                    return true;
                default:
                    return false;
            }
        }
    } else if (order.__typename === 'UnclaimedPrescriberOrder') {
        return true;
    }
    return false;
};
